import { CartLinesUpdateEvent } from '@shopify/events';

class KubiCartUpgrade extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.querySelector('button')?.addEventListener('click', () => this.upgrade(), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  async upgrade() {
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    if (button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.hidden = false;
    status.textContent = this.dataset.loading;
    let deferred;
    try {
      const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } });
      const productResponse = await fetch(`${this.dataset.productUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok || !productResponse.ok) throw new Error('Unavailable');
      const cart = await cartResponse.json();
      const product = await productResponse.json();
      const singles = cart.items.filter(item => String(item.variant_id) === this.dataset.single);
      const pair = product.variants.find(variant => String(variant.id) === this.dataset.pair);
      const single = singles[0];
      if (singles.length !== 1 || single.quantity !== 1 || Object.keys(single.properties || {}).length || single.selling_plan_allocation || cart.total_discount || cart.items.some(item => String(item.variant_id) === this.dataset.pair) || !pair?.available || pair.price !== Number(this.dataset.pairPrice)) throw new Error('Cart changed');
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map(item => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(Theme.routes.cart_update_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: { [single.key]: 0, [this.dataset.pair]: 1 }, sections: sectionIds, sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok || result.errors || result.status) throw new Error('Update failed');
      deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [{ id: String(this.dataset.pair), quantity: 1 }], promise: deferred.promise }));
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(result), detail: { sections: result.sections, items: result.items, itemCount: result.item_count, source: 'kubi-upgrade', didError: false } });
      status.textContent = this.dataset.success;
      document.dispatchEvent(new CustomEvent('kubi:interaction', { detail: { action: 'upgrade', component: 'cart-offer' } }));
    } catch {
      status.textContent = this.dataset.error;
      button.disabled = false;
    } finally { button.removeAttribute('aria-busy'); }
  }
}
if (!customElements.get('kubi-cart-upgrade')) customElements.define('kubi-cart-upgrade', KubiCartUpgrade);
